import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User, Comment } from '../types/user'
import { AppState } from '../types/app-state'
import { Group } from '../types/group'
import { Subject } from '../types/subject'
import { SubjectGroup } from '../types/subject-group'
import { SelectedSubject } from '../types/selected-subject'

export enum Role {
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT'
};

export interface UserState {
  username: string | null
  role: Role | null
  firstName: string | null
  lastName: string | null
  email: string | null
  isEmailConfirmed: boolean
  users: User[]
  app: AppState | null
  groups: Group[]
  subjects: Subject[]
  subjectGroups: SubjectGroup[]
  selectedSubjects: SelectedSubject[]
  myStudentGroups: Group[]
  comments: Comment[]
  commentedComments: Comment[]
  studentsSelections: Array<User & { selectedSubjects: SelectedSubject[] }>
}

const initialState: UserState = {
  username: null,
  role: null,
  firstName: null,
  lastName: null,
  email: null,
  isEmailConfirmed: false,
  users: [],
  app: null,
  groups: [],
  subjects: [],
  subjectGroups: [],
  selectedSubjects: [],
  myStudentGroups: [],
  studentsSelections: [],
  comments: [],
  commentedComments: []
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set: (state: UserState, action: PayloadAction<UserState>) => {
      const { username, email, isEmailConfirmed, firstName, lastName, role, users, app, groups, subjects, subjectGroups, selectedSubjects, myStudentGroups, studentsSelections, comments, commentedComments } = action.payload

      state.username = username
      state.role = role
      state.firstName = firstName
      state.lastName = lastName
      state.email = email
      state.isEmailConfirmed = isEmailConfirmed
      state.users = users
      state.app = app
      state.groups = groups
      state.subjects = subjects
      state.subjectGroups = subjectGroups
      state.selectedSubjects = selectedSubjects
      state.myStudentGroups = myStudentGroups
      state.studentsSelections = studentsSelections
      state.comments = comments
      state.commentedComments = commentedComments
    },
    reset: (state: UserState) => {
      state.username = null
      state.role = null
      state.firstName = null
      state.lastName = null
      state.email = null
      state.isEmailConfirmed = false
      state.users = []
      state.app = null
      state.groups = []
      state.subjects = []
      state.subjectGroups = []
      state.selectedSubjects = []
      state.myStudentGroups = []
      state.studentsSelections = []
      state.comments = []
      state.commentedComments = []
    }
  }
})

export const UserActions = userSlice.actions

export default userSlice.reducer
